function Base({ orientation }) {
  if (orientation === 'horizontal') {
    return (
      <div
        style={{
          width: '100%',
          height: '1px',
          backgroundColor: '#e5e5e5',
        }}
      />
    );
  } else {
    return (
      <div
        style={{
          height: 'auto',
          borderLeft: '1px solid #e5e5e5'
        }}
      />
    );
  }
}

function Horizontal() {
  return <Base orientation="horizontal" />;
}

function Vertical() {
  return <Base orientation="vertical" />;
}

export const Divider = {
  Horizontal,
  Vertical,
};
